import React, { PureComponent } from 'react';
import styles from './index.css';
/**
 * 视频title组件
 */
class Title extends PureComponent {
    render() {
        const { title, titleShow } = this.props;
        return React.createElement("div", { className: `${styles.titleLine} ${titleShow ? '' : styles.titleLineHide}` }, title);
    }
}
export default Title;
